import 'twin.macro';
import { SwatchIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';
import { tagBackgroundColors, tagTextColor } from 'styles/userConstants';
import { css } from 'twin.macro';

export function DomaineIcon(props: IconProps) {
  return (
    <SwatchIcon
      tw="p-1 rounded-lg"
      css={[
        css`
          background-color: ${tagBackgroundColors['cassis-quiet']};
          color: ${tagTextColor.cassis};
        `,
      ]}
      className={props.className}
      {...props}
    />
  );
}
